export const SITE = {
    name: 'KickerEck',
    url: 'https://www.kickereck.com',
    title: 'KickerEck - Kickern in Dortmund',
    description:
        'KickerEck – Kickern und Tischfußball in Dortmund. Kalender, Turniere, Mini-Challenger und alle Infos rund um das KickerEck in der Sendstraße 100-102.',
    image: 'https://www.kickereck.com/img/gallery/KickerEck.jpg',
    locale: 'de_DE',
};

export const VENUE = {
    name: 'KickerEck',
    url: 'https://www.kickereck.com/',
    telephone: '+4917656061274',
    email: 'kickereck@gmail.com',
    sameAs: ['https://www.facebook.com/Tischfussballverstrahlt'],
    address: {
        '@type': 'PostalAddress',
        streetAddress: 'Sendstraße 100-102',
        postalCode: '44143',
        addressLocality: 'Dortmund',
        addressCountry: 'DE',
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 51.524616,
        longitude: 7.528551,
    },
    openingHours: [
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Tuesday'],
            opens: '18:00',
            closes: '22:00',
        },
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Friday'],
            opens: '18:00',
            closes: '22:00',
        },
    ],
};

export const PAGE_META = {
    '/': {
        title: SITE.title,
        description: SITE.description,
    },
    '/aktuelles': {
        title: 'Aktuelles | KickerEck Dortmund',
        description: 'Neuigkeiten vom KickerEck – Termine, Ergebnisse und Berichte aus Dortmund.',
    },
    '/gallery': {
        title: 'Galerie | KickerEck Dortmund',
        description: 'Bilder aus dem KickerEck – Eindrücke von Turnieren, Events und der Location in Dortmund.',
    },
    '/veranstaltungen': {
        title: 'Veranstaltungen & Buchung | KickerEck Dortmund',
        description: 'Veranstaltungen im KickerEck Dortmund – Termine ansehen, buchen und stornieren.',
    },
    '/challenger': {
        title: 'Mini-Challenger Anmeldung | KickerEck Dortmund',
        description: 'Anmeldung zum Mini-Challenger im KickerEck Dortmund – jetzt für das nächste Turnier registrieren.',
    },
    '/address': {
        title: 'Anfahrt | KickerEck Dortmund',
        description: 'So findest du das KickerEck: Sendstraße 100-102, 44143 Dortmund. Anfahrt, Parken und Wegbeschreibung.',
    },
    '/impressum': {
        title: 'Impressum | KickerEck Dortmund',
        description: 'Impressum und rechtliche Angaben zum KickerEck Dortmund.',
    },
    '/datenschutz-app': {
        title: 'Datenschutz App | KickerEck Dortmund',
        description: 'Datenschutzerklärung der KickerEck-App.',
    },
    '/storno': {
        title: 'Storno | KickerEck Dortmund',
        description: 'Buchung beim KickerEck Dortmund stornieren.',
    },
    '/admin': {
        title: 'Admin | KickerEck Dortmund',
        description: 'Administrationsbereich des KickerEck.',
    },
};
